import * as React from 'react';
export const mbwaySvg = React.forwardRef(function mbwaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.566 16H1.434c-1.51 0-1.524-1.383-1.37-2.207.083-.555.988-.55 1.087 0v.643c0 .294.231.535.513.535h12.671c.283 0 .514-.24.514-.535v-.643c.1-.55 1.004-.555 1.088 0 .153.824.138 2.207-1.37 2.207h-.001ZM13.475 0c.716 0 1.302.326 1.302 1.115v.686c0 .97-1.26.966-1.26.007v-.375A.438.438 0 0 0 13.1 1H2.89a.438.438 0 0 0-.416.433V1.8c0 .964-1.202.957-1.202.02v-.705C1.271.326 1.857 0 2.573 0h10.902Zm1.045 7.882a2.139 2.139 0 0 1 1.193 1.879c0 1.155-.969 2.1-2.153 2.1h-3.318a.576.576 0 0 1-.565-.55V4.735c0-.317.25-.577.555-.577h2.764c1.163 0 2.115.99 2.115 2.201a2.24 2.24 0 0 1-.591 1.523Zm-2.477-.536h1.054v-.012c.48-.077.85-.511.85-1.032 0-.574-.45-1.043-1.002-1.043h-2.122v5.457h2.691c.57 0 1.035-.485 1.035-1.078 0-.593-.466-1.078-1.035-1.078l-1.471-.002a.613.613 0 0 1-.582-.606c0-.333.262-.606.582-.606ZM9.15 11.205a.707.707 0 0 1-.592.763.685.685 0 0 1-.732-.617l-.546-5.23-1.933 5.114-.002.005a.707.707 0 0 1-.645.441c-.269-.01-.49-.204-.596-.441L2.17 6.122l-.546 5.23a.685.685 0 0 1-.732.616.707.707 0 0 1-.592-.763l.643-6.166.001-.004c.06-.576.566-1.047 1.156-1.023h.002c.439.024.82.313.976.725l1.647 4.357L6.37 4.737a1.106 1.106 0 0 1 1.183-.715c.51.073.898.508.952 1.013v.003l.645 6.167Z',
      clipRule: 'evenodd',
    }),
  );
});
mbwaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mbway = {
  category: 'paymentmethod',
  colorable: true,
  name: 'mbway',
  svg: mbwaySvg,
};
